import { render, staticRenderFns } from "./PopupTerms.vue?vue&type=template&id=38104258&"
import script from "./PopupTerms.vue?vue&type=script&lang=js&"
export * from "./PopupTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports